// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, Section, Input, Slider, Button } from '@telegram-apps/telegram-ui';

// VK
import { Avatar } from '@vkontakte/vkui';
import { Icon24PicturePlusOutline, Icon20DeleteOutline } from '@vkontakte/icons';

const tg = window.Telegram.WebApp;

const RssPage = ({ activePanel, setActivePanel, avatarSrc, selectedGroup }) => {
    const inputRef = useRef(null);
    const fileInputRef = useRef(null);
    const [count, setCount] = useState(selectedGroup.rss_count);
    const [channelName, setChannelName] = useState(selectedGroup.name);
    const [avatar, setAvatar] = useState(avatarSrc);

    useEffect(() => {
        if (activePanel === 'rss') {
            inputRef.current?.focus();
            tg.BackButton.show();
            tg.BackButton.onClick(() => setActivePanel('channel'));
        }
        return () => tg.BackButton.offClick(() => setActivePanel('channel'));
    }, [activePanel, setActivePanel]);

    useEffect(() => {
        const updateRssCount = async () => {
            try {
                await fetch("https://api.gmpapp.ru/update_rss_channel", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        channel_id: selectedGroup.id,
                        rss_count: count,
                    }),
                });
            } catch (err) {
                console.error("Ошибка при обновлении rss_count:", err);
            }
        };
    
        updateRssCount();
    }, [count, selectedGroup.id]);    

    const handleDeleteRSS = () => {
        tg.HapticFeedback.impactOccurred('heavy');
        tg.HapticFeedback.notificationOccurred("success");

        tg.showPopup({
            title: "Удаление ленты",
            message: "Вы действительно хотите удалить RSS-ленту? Все настройки данной ленты будут потеряны безвозвратно",
            buttons: [
                { id: 'ok', type: 'destructive', text: 'Удалить' },
                { id: 'cancel', type: 'cancel' },
            ]
        }, async (buttonId) => {
            if (buttonId === 'cancel') {
                console.log("Действие отменено");
            } else if (buttonId === 'ok') {
                try {
                    const response = await fetch("https://api.gmpapp.ru/delete_rss_feed", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ channel_id: selectedGroup.id })
                    });

                    if (response.ok) {
                        console.log("RSS-лента удалена");
                        setActivePanel("home");
                    } else {
                        const error = await response.json();
                        console.error("Ошибка удаления:", error);
                    }
                } catch (err) {
                    console.error("Ошибка запроса:", err);
                }
            }
        });
    };


    const handleAvatarChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = () => {
            const img = new Image();
            img.onload = async () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                // JPEG с качеством 0.9
                const jpegDataUrl = canvas.toDataURL("image/jpeg", 0.9);
                const base64 = jpegDataUrl.split(',')[1];

                setAvatar(jpegDataUrl); // Показываем аватар

                try {
                    await fetch("https://api.gmpapp.ru/update_rss_channel", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            channel_id: selectedGroup.id,
                            channel_pic_base64: base64,
                        }),
                    });
                } catch (err) {
                    console.error("Ошибка при обновлении аватара:", err);
                }
            };
            img.src = reader.result;
        };

        reader.readAsDataURL(file);
    };


    const handleRename = async (e) => {
        const newName = e.target.value;
        setChannelName(newName);

        try {
            await fetch("https://api.gmpapp.ru/update_rss_channel", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    channel_id: selectedGroup.id,
                    channel_title: newName,
                }),
            });
        } catch (err) {
            console.error("Ошибка при переименовании:", err);
        }
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform="ios">
                <Section
                    className="sectionChannelStreams sectionChannelRss"
                    header="Аватар и название"
                    footer="Здесь вы можете сменить аватар и название вашей RSS-ленты"
                >
                    <Input
                        before={
                            <Avatar
                                className="channelAvatar"
                                size={48}
                                src={avatar}
                                initials={channelName.substring(0, 2)}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <Avatar.Overlay style={{ cursor: 'pointer' }} visibility="always" aria-label="Кнопка для изображения">
                                    <Icon24PicturePlusOutline />
                                </Avatar.Overlay>
                            </Avatar>
                        }
                        ref={inputRef}
                        value={channelName}
                        onChange={handleRename}
                    />
                    <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleAvatarChange}
                    />
                </Section>
                <Section className='sectionChannelStyle tempStyle' header="Новостей в ленте" footer="Чтобы не перегружать RSS вы можете выбрать необходимое количество последних новостей в ленте">
                    <Slider className='rssItems' step={5} min={10} max={40} defaultValue={count} onChange={(val) => setCount(val)} after={`${count} последних новостей`} />
                </Section>
                <Section className='sectionChannelStyle' header="Удаление ленты" footer="Если RSS-лента больше неактуальна для вас, то по кнопке выше вы можете её удалить">
                    <Button className='deleteRss' onClick={handleDeleteRSS} mode="filled" size="l" stretched before={<Icon20DeleteOutline />}>Удалить RSS-ленту</Button>
                </Section>
            </AppRoot>
        </div>
    );
};

export default RssPage;